<template>
  <div class="zj-emergency-task-list select-none">
    <div>
      <div>采用预案：{{this.planName}}</div>
      <div class="detail-btn" @click="viewDetail">详情</div>
    </div>
    <el-tabs class="custom-tabs child-tabs" v-model="activeName">
      <el-tab-pane label="全部任务" name="first">
        <el-table :data="tableData" :show-header="false" stripe="false">
          <el-table-column>
            <template slot-scope="scope">
              <div class="task-row select-none">
                <div :class="statusClass(scope.row.status)">{{optionsObj[scope.row.status]}}</div>
                <div class="detail">
                  <div>{{scope.$index + 1}}.{{scope.row.taskName + scope.row.taskDesc}}</div>
                </div>
                 <div class="btn-start" @click="handleStart(scope.row)" v-if="scope.row.status == 1">启动</div>
                <div class="btn-close" @click="handleClose(scope.row)" v-if="scope.row.status == 1 || scope.row.status == 3">关闭</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="异常任务" name="second">
        <el-table :data="exceptionTask" @row-click="rowclick" :show-header="false">
          <el-table-column>
            <template slot-scope="scope">
              <div class="task-row select-none">
                <div :class="statusClass(scope.row.status)">{{optionsObj[scope.row.status]}}</div>
                <div class="detail">
                  <div>{{scope.$index + 1}}.{{scope.row.taskName + scope.row.taskDesc}}</div>
                </div>
                <!-- <div class="btn-start" @click="handleStart(scope.row)" v-if="scope.row.status == 1">启动</div> -->
                <div class="btn-close" @click="handleClose(scope.row)" v-if="scope.row.status == 1 || scope.row.status == 3">关闭</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isVisiable"
    >
      <PlanDetail v-bind:query="{ id:this.planId, type:'search' }" />
    </el-dialog>
    <el-dialog
      class="emergencyoperations-dialog thin"
      custom-class="bg2"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isFeedbackVisiable"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <Feedback @handlerclose="isFeedbackVisiable=false" v-bind:currentTask="currentTask" :form="{}" />
    </el-dialog>
  </div>
</template>
<script>
import ZJApp from "../../../../../../app";
import PlanDetail from "./../../Plan/PlanManage";
import Feedback from "./Component-TaskFeedback";
import { executeTask } from "@/api/src/emergency_event";
export default {
  name: "ZJEmergencyComponentTaskList",
  componentName: "ZJEmergencyComponentTaskList",
  components: {
    PlanDetail: PlanDetail,
    Feedback: Feedback
  },
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    optionsObj:Object,
    planName: String,
    planId: String
  },
  data() {
    return {
      startTaskMsgKey: "MessageKey_EmergencyEventStartTask",
      activeName: "first",
      isVisiable: false,
      isFeedbackVisiable: false,
      currentTask: {}
    };
  },
  methods: {
    statusClass: function(status) {
      return {
        processing:
          status == 3,
        todo:
          status == 1,
        finished:
          status == 4 || status == 2
      };
    },
    // eslint-disable-next-line no-unused-vars
    handleStart: function(row) {
      executeTask({taskId:row.id, username:ZJApp.ZJUser.current.UserName }).then(r => {
        console.log(r)
        if(r.code == 0){
          this.$message({message:"任务已启动",type:"success"});
          var msgcontent = {
            key: this.startTaskMsgKey,
            data: row.id
          };
          this.$notify.broadcase(msgcontent);
        }else{
          this.$message({message:"任务启动失败",type:"erroe"});
        }
      })
    },
    // eslint-disable-next-line no-unused-vars
    handleClose: function(row) {
      this.currentTask = JSON.parse(JSON.stringify(row));
      this.isFeedbackVisiable = true;
    },
    // eslint-disable-next-line no-unused-vars
    viewDetail: function() {
      this.isVisiable = true;
    }
  },
  computed: {
    exceptionTask: function() {
      var result = this.tableData.filter(function(item) {
        return (
          item.status == 3
        );
      });
      return result;
    }
  },
  watch: {}
};
</script>